import AppBreadcrumb from "./AppBreadcrumb.vue";

export { AppBreadcrumb };
